import { Outlet } from "react-router-dom";

// The fixed header's offset now lives in App.tsx, alongside the condition that
// decides whether the header renders at all — applying it here as well would
// double the gap on these routes. This layout's remaining job is the `main`
// landmark that the header's "Skip to content" link targets. (The link itself
// has to live in the Header, which renders ahead of this in the DOM, so that it
// is the first tab stop.)
const PaddedLayout = () => (
  <main id="main" tabIndex={-1} className="focus:outline-none">
    <Outlet />
  </main>
);

export default PaddedLayout;
